import React, { Component } from 'react';
import * as styled from '../../styles/style';
import { RadioField } from './eventFormComponents';
import { validString, validEmail } from '../../helpers/check-required-fields';
let bcrypt = require('bcryptjs');

class SignupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      endpoint: this.props.endpoint,
      submitting: false,
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      submitting: true
    }, () => {
      window.setTimeout(() => {
        this.setState({
          submitting: false
        });
      }, 2000)
    })

    let password_digest

    if (this.state.password !== undefined) {
      password_digest = bcrypt.hashSync(this.state.password, 8);
    }
    this.props.handleSubmit(this.state.email, password_digest);
  }

  render() {
    const message = (<styled.Disclaimer>By registering as an On the Table host, you accept our <a target="_blank" href={process.env.REACT_APP_BASE_URL + "/legal"}>terms and privacy policy</a>.</styled.Disclaimer>);
    const valid = validEmail(this.state.email) && validString(this.state.password) && !this.state.submitting
    return (
      <form onSubmit={this.handleSubmit}>
        <styled.FormRow>
          <styled.FullWidthFieldGroup>
            <styled.Label required htmlFor="email">Email</styled.Label>
            <styled.FormField public value={this.state.email} id="email" name="email" type="email" onChange={this.handleChange} />
          </styled.FullWidthFieldGroup>
        </styled.FormRow>
        <styled.FormRow>
          <styled.FullWidthFieldGroup>
            <styled.Label required htmlFor="password">Password</styled.Label>
            <styled.FormField public value={this.state.password} id="password" name="password" type="password" onChange={this.handleChange} />
          </styled.FullWidthFieldGroup>
        </styled.FormRow>
        <styled.ButtonGroup>
          <styled.Button disabled={!valid} type="submit" value="Register" />
        </styled.ButtonGroup>
        {message}
      </form>
    )
  }
}

export default SignupForm
